<template>
  <div class="ResearchUnitpage">
    <div class="leftbox">
      <el-menu
      :default-active="defaultididx"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect">
      <template v-for="(item,index) in treedata" >
        <el-submenu :index="item.ididx" v-if="item.children&&item.children.length>0" >
          <template slot="title">
          {{item.label}}
          </template>
          <el-menu-item-group >
            <el-menu-item  :index="itemc.ididx" v-for="(itemc,indexc) in item.children" :key='indexc'>{{itemc.label}}</el-menu-item>
          </el-menu-item-group>
      </el-submenu>
      <el-menu-item :index="item.ididx" v-else>
        <div slot="title" class="el-menuf">{{item.label}}</div>
      </el-menu-item>
      </template>
    </el-menu>
    </div>
    <div class="rightbox">
      <div class="title">
        <div class="menuname">{{recordsDataTitle?recordsDataTitle:'--'}}</div>
      </div>
      <div class="content">
        <div class="tableheader">
          <div class="ttitle">标题</div>
          <div class="classification">分类</div>
          <div class="label">标签</div>
          <div class="operation">操作</div>
        </div>
        <ul class="themelist" v-loading="recordsloading">
          <!-- <li v-for="(item,index) in recordsData" :key="index"> -->
          <li v-for="(item,index) in showrecordsData" :key="index">
            <div class="ttitle" @click="previewKmDoc(item)">{{item.title}}</div>
            <div class="classification">{{item.category_dictText?item.category_dictText:'--'}}</div>
            <div class="label" v-if="item.businessType_dictTextArr.length>0">
              <span v-for="(item1,index1) in item.businessType_dictTextArr" :key="index1">{{item1}}</span>
            </div>
            <div v-else class="label">--</div>
            <div class="operation">
              <i class="iconfont icon-xiazai4"  @click="downloadKmDoc(item)"></i>
              <!-- <span></span>
              <i v-if="recordsData[index].isShouchang" class="iconfont icon-shoucang" @click="shouChangFn(index)"></i>
              <i v-else class="iconfont icon-shoucang3" @click="shouChangFn(index)"></i> -->
            </div>
          </li>
          <li class="nodata" v-if="recordsData.length==0">暂无数据</li>
        </ul>
        <div class="paginationbox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordsData.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <p-d-f-modal iframe-i-d="pdfIDde" :p-d-furl="PDFurl" :showmodel="showmodel" :title="pdftitle" @closepdfmodel='closePdfModel'/>
  </div>
</template>

<script>
import api from "@/api/home.js"
import Vue from 'vue'
import {Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,} from 'element-ui';
  Vue.use(Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,);
  import PDFModal  from '@/components/common/PDFModal/index.vue'
  import commonUrl from '@/assets/js/baseurl'
export default {
  name: 'zhuanti',
  props: {
    msg: String
  },
  components:{
    PDFModal,
  },
  data() {
      return {
        currentPage4: 1,
        treedata:[],
        recordsData:[],
        showrecordsData:[],
        recordsloading:false,
        recordsDataTitle:'',
        defaultididx:'',
        pagesize:10,
        pageindex:1,
        url: {
          previewKmDoc: commonUrl.baseUrl+'/ky/KM/kmDoc/new/previewKmDoc',
          downloadKmDoc: commonUrl.baseUrl+'/ky/KM/kmDoc/new/downloadKmDoc',
        },
        PDFurl:'',
        pdftitle:'',
        showmodel:false,

      };
    },
    created(){
      this.getloadTreeData();
      if(this.$route.params.code){
        this.recordsDataTitle=this.$route.params.label
        this.searchDoc(this.$route.params.code)
      }
  },
  methods: {
     // 显示预览窗口，初始化
      previewKmDoc(record) {
        console.log(record,123)
        this.PDFurl =  this.url.previewKmDoc + "?docId=" + record.id;
        this.pdftitle ='预览 - ' + record.title;
        this.showmodel=true;
      },
      closePdfModel(){
        this.showmodel=false;

      },
      //下载文件
      downloadKmDoc(record) {
        this.$message.warning('文件开始下载');
        api.downloadFileName(this.url.downloadKmDoc, {docId: record.id},this.$message)
      },

      handleOpen(key, keyPath) {
        console.log('open',key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log('close',key, keyPath);
      },
      handleSelect(key, keyPath) {
        // console.log('elsect',key, keyPath);
        let idxarr=key.split('-');
        let topicCodes=''
        if(idxarr[0]=='z'){
          topicCodes=this.treedata[idxarr[1]].code
          this.recordsDataTitle=this.treedata[idxarr[1]].label
        }else{
          topicCodes=this.treedata[idxarr[0]].children[idxarr[1]].code
          this.recordsDataTitle=this.treedata[idxarr[0]].children[idxarr[1]].label
        }
        this.searchDoc(topicCodes)
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pagesize=val;
        this.showrecordsData=this.recordsData.slice((this.pageindex-1)*this.pagesize,(this.pageindex-1)*this.pagesize+this.pagesize);
      },
      handleCurrentChange(val) {
        console.log(`第 ${val} ye`);
        this.pageindex=val;
        this.showrecordsData=this.recordsData.slice((this.pageindex-1)*this.pagesize,(this.pageindex-1)*this.pagesize+this.pagesize);

      },
      searchDoc(topicCodes){
        this.recordsloading=true;
        api.searchDoc({
          column:'_score',order:'desc',field:'id,,,title,category_dictText,businessType_dictText,action',pageNo:1,pageSize:1000,topicCodes:topicCodes,
        }).then((res)=>{
          this.recordsloading=false;
          if(res.code==200&&res.result&&res.result.kmSearchResultVOPage&&res.result.kmSearchResultVOPage.records.length>0){
            let newArr= res.result.kmSearchResultVOPage.records.map((item)=>{
              item.isShouchang=false;
              item.businessType_dictTextArr=[];
              if(item.businessType_dictText){
                item.businessType_dictTextArr=item.businessType_dictText.split(',');
              }
              return item
            })
            this.recordsData=newArr;
          }else{
            this.recordsData=[];

          }
            this.showrecordsData=this.recordsData.slice(0,10);
            window.scrollTo(0, 100 )
        }).catch((err) => {
          });
      },
      shouChangFn(idx){
        this.recordsData[idx].isShouchang = !this.recordsData[idx].isShouchang;
      },
      getloadTreeData(){
        //专题分类
        let params = {
          async: false,
          pcode: ""
        };
        api.getloadTreeData(params)
          .then((res)=>{
            let treedatadiy=[]
            if(res.code==0&&res.result.length>0){
              this.treedata= this.diyTreeDataFn(res.result,'z');
              if(this.treedata.length>0){
                if(this.treedata[0].children.length>0){
                  this.defaultididx='0-0'
                }else{
                  this.defaultididx='z-0'
                }
                if(!this.$route.params.code){
                  this.handleSelect(this.defaultididx)
                }else{
                  this.defaultididx=''
                  
                }
              }
            }
          }).catch((err) => {
          });
      },
      diyTreeDataFn(data,i_c){
        let that=this;
        let treearr=[]
        for(let i in data){
          if(data[i].children&&data[i].children.length>0){
            
            treearr.push({
              label: data[i].title,
              ididx: i_c + '-'+i,
              code:data[i].code,
              children:that.diyTreeDataFn(data[i].children,i)
            })
          }else{
            treearr.push({
              label: data[i].title,
              ididx: i_c + '-'+i,
              code:data[i].code,
            })
          }
        }
          return treearr
      },
    },
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.ResearchUnitpage{
  width: 1200px;
  margin: 0 auto;
  padding-top: 16px;
  padding-bottom: 64px;
  overflow: hidden;
  .leftbox{
    width: 240px;
    float: left;
    margin-left: 16px;
    .el-submenu{
      width: 240px;
      
      background: #F6F6F6;
      border-radius: 4px;
      margin-bottom: 4px;
      .el-submenu__title{
        padding-left: 24px;
        padding-right: 16px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #25365E;
      }
    }
    .el-menu>.el-menu-item{
      width: 240px;
      
      background: #F6F6F6;
      border-radius: 4px;
      margin-bottom: 4px;
      height: 48px;
        line-height: 48px;
      .el-menuf{
        padding-left: 24px;
        padding-right: 16px;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #25365E;
      }
    }
    .el-menu-item.is-active , .el-menu-item.is-active div{
      background-color: #FFFFFF;
      color: #376EF4 !important;
    }
    .el-menu{
      border: none;
    }
    .el-menu.el-menu--inline{
      box-shadow: 0px 0px 8px 0px rgba(137,154,176,0.2);
      padding-bottom: 20px;
    }
    .el-menu-item{
      font-size: 14px;
font-family: Source Han Sans CN;
font-weight: 400;
color: #333333;
width: 208px;
height: 32px;
line-height: 32px;
border-bottom: 1px dotted #E6E6E6;
margin: 0 auto;
padding: 0;
padding-left: 0px !important;
    }
    .el-menu-item-group__title{
      padding-top: 5px;
      padding-bottom: 5px;
    }
    .el-menu-item.is-active{
      background-color: #FFFFFF;
      color: #376EF4;
    }
    .el-menu-item:hover{
      color: #376EF4;
      background-color: #FFFFFF;
    }
  }
  .rightbox{
    float: right;
    width: 924px;
    // height: 590px;
    padding-bottom: 18px;
    background: #FFFFFF;
    border: 1px solid #E6E6E6;
    .title{
      width: 892px;
      margin: 0 auto;
      border-bottom: 2px solid #376EF4;
      margin-top: 12px;
      margin-bottom: 16px;
      .menuname{
        width: 172px;
      height: 36px;
      background: #376EF4;
      border-radius: 4px 4px 0px 0px;
      margin-left: 8px;
      line-height: 36px;
      color: #FFFFFF;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      text-align: center;
      }
    }
    .content{
      width: 892px;
      margin: 0 auto;
      padding-bottom: 58px;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px 0px rgba(137,154,176,0.2);
      position: relative;
      .tableheader{
        width: 100%;
        height: 40px;
        background: #F9F9F9;
        overflow: hidden;
        &>div{
          float: left;
          line-height: 40px;
          font-size: 14px;
font-family: Source Han Sans CN;
font-weight: 400;
color: #333333;
        }
        
      }
          .ttitle{
            width: 496px;
            padding-left: 16px;
            box-sizing: border-box;
            height: 40px;
            cursor: pointer;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            padding-right: 20px;
          }
          .classification{
            width: 118px;
            height: 40px;
          }
          .label{
            width: 202px;
            height: 40px;
            overflow: hidden;
          }
          .operation{
            height: 40px;
          }
      .themelist{
          width: 100%;
          min-height: 400px;
          &>li{
            height: 40px;
            border-bottom: 1px solid #f5f5f5;
            &>div{
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 40px;
              float: left;
            }
            .label{
              span{
                display: inline-block;
                // width: 43px;
                padding: 0 8px;
                height: 20px;
                background-color: #FFF5DC;
                border-radius: 4px;
                text-align: center;
                line-height: 20px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #FFBF27;
                margin-right: 4px;
              }
            }
            .operation{
              .iconfont{
                color: #376EF4;
                font-size: 14px;
                cursor: pointer;
                margin-left: 8px;
              }
              span{
                display: inline-block;
                width: 1px;
                height: 8px;
                background: #5E6463;
                margin: 0 12px;
              }
            }
          }
          &>li:hover{
            background: #F6F9FF;
          }
          .nodata{
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 400px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999;
          }
        }
      .paginationbox{
        font-size: 13px;

        font-weight: 400;
        color: #333333;
        position: absolute;
        bottom: 12px;
        right: 16px;
      }
    }
  }
}
</style>
